import fs from 'node:fs';
import path from 'node:path';
import os from 'node:os';
import type { Database } from 'node-sqlite3-wasm';
import { moveLegacyFileToOldVersionBackup } from './archive-to-old-version.js';

export const LEGACY_AGENT_SESSION_DIR = path.join(os.homedir(), '.buildautomaton', 'agent-sessions');

/** Import `~/.buildautomaton/agent-sessions/*.json` into `agent_session`, then archive each file. */
export function importLegacyAgentSessionsFromDisk(db: Database): void {
  try {
    if (!fs.existsSync(LEGACY_AGENT_SESSION_DIR)) return;
    const names = fs.readdirSync(LEGACY_AGENT_SESSION_DIR).filter((n) => n.endsWith('.json'));
    for (const name of names) {
      const sessionKey = name.slice(0, -'.json'.length);
      const full = path.join(LEGACY_AGENT_SESSION_DIR, name);
      let raw: string;
      try {
        raw = fs.readFileSync(full, 'utf8');
      } catch {
        continue;
      }
      let parsed: {
        v?: unknown;
        acpSessionId?: unknown;
        backendAgentType?: unknown;
        configOptions?: unknown;
        updatedAt?: unknown;
      };
      try {
        parsed = JSON.parse(raw) as typeof parsed;
      } catch {
        continue;
      }
      if (parsed.v !== 1) continue;
      const acpSessionId = typeof parsed.acpSessionId === 'string' ? parsed.acpSessionId : null;
      const backendAgentType = typeof parsed.backendAgentType === 'string' ? parsed.backendAgentType : null;
      const configOptionsJson =
        Array.isArray(parsed.configOptions) ? JSON.stringify(parsed.configOptions) : null;
      const updatedAt =
        typeof parsed.updatedAt === 'string' ? parsed.updatedAt : new Date().toISOString();
      db.run(
        `INSERT OR REPLACE INTO agent_session (session_key, acp_session_id, backend_agent_type, config_options_json, updated_at)
         VALUES (?, ?, ?, ?, ?)`,
        [sessionKey, acpSessionId, backendAgentType, configOptionsJson, updatedAt],
      );
      try {
        moveLegacyFileToOldVersionBackup('agent-sessions', full);
      } catch {
        /* ignore */
      }
    }
  } catch (e) {
    console.error('[cli-sqlite] legacy import: agent_sessions from disk failed', e);
  }
}
